/**
 * GA4 via gtag — initialized in /api/v1/session/currentEnv and index template.
 * @see docs/google-analytics-user-events-plan.md
 */

function gtagAvailable() {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

export function trackEvent(eventName, eventParams) {
  if (!gtagAvailable()) {
    return;
  }
  window.gtag('event', eventName, eventParams || {});
}

export function trackPageView(options) {
  if (!gtagAvailable()) {
    return;
  }
  const opts = options || {};
  const pagePath = (opts.page_path !== undefined && opts.page_path !== null)
    ? opts.page_path
    : (window.location.pathname + window.location.search);
  const pageLocation = (opts.page_location !== undefined && opts.page_location !== null)
    ? opts.page_location
    : (window.location.origin + pagePath);
  if (opts.user_id) {
    window.gtag('set', { user_id: String(opts.user_id) });
  }
  const params = {
    page_path: pagePath,
    page_location: pageLocation,
    page_title: (opts.page_title !== undefined && opts.page_title !== null)
      ? opts.page_title
      : (typeof document !== 'undefined' ? document.title : '')
  };
  if (opts.tool) {
    params.tool = opts.tool;
  }
  window.gtag('event', 'page_view', params);
}



// WEBPACK FOOTER //
// ./src/utils/analytics.js